module.exports = __webpack_public_path__ + "assets/img/familyCrest-4a295582.png";